// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------------------------------------------------------
# Filters
--------------------------------------------------------------*/
.WqDznpprgABHOjTOo0dc {
  background-color: var(--surface-color);
  padding: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
}
.WqDznpprgABHOjTOo0dc .RBLBzJOqhtZby3nB1A7X {
  font-family: Rubik;
  font-weight: 500;
  font-size: 24px;
  border-bottom: 1px solid #C3CFE7;
  padding-bottom: 15px;
  padding-top: 5px;
  margin-bottom: 20px;
}

.L36o4cW3F4ELrp95iHA1 {
  color: #0C3058;
  font-size: 20px;
  font-weight: 500;
  padding: 0;
  font-family: "Rubik";
  margin-bottom: 15px;
}

.TFKBFReFWwi_Mq3lQIMr {
  margin-bottom: 20px;
  border-bottom: 1px solid #C3CFE7;
}
.TFKBFReFWwi_Mq3lQIMr:last-child {
  margin-bottom: 0;
  border-bottom: 0;
}

@media (max-width: 991.98px) {
  .WqDznpprgABHOjTOo0dc {
    box-shadow: none;
    border-radius: 0;
  }
}`, "",{"version":3,"sources":["webpack://./GeneralComponents/SearchResults/searchFilters/SearchFilters.module.scss"],"names":[],"mappings":"AAAA;;+DAAA;AAGA;EACI,sCAAA;EACA,aAAA;EACA,yCAAA;EACA,mBAAA;AACJ;AACI;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;AACR;;AAGA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;AAAJ;;AAGA;EACE,mBAAA;EACA,gCAAA;AAAF;AAEE;EACE,gBAAA;EACA,gBAAA;AAAJ;;AAKA;EACI;IACI,gBAAA;IACA,gBAAA;EAFN;AACF","sourcesContent":["/*--------------------------------------------------------------\r\n# Filters\r\n--------------------------------------------------------------*/\r\n.filters-container {\r\n    background-color: var(--surface-color);\r\n    padding: 16px;\r\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\r\n    border-radius: 15px;\r\n\r\n    .filters-title-label {\r\n        font-family: Rubik;\r\n        font-weight: 500;\r\n        font-size: 24px;\r\n        border-bottom: 1px solid #C3CFE7;\r\n        padding-bottom: 15px;\r\n        padding-top: 5px;\r\n        margin-bottom: 20px;\r\n    }\r\n}\r\n\r\n.filter-title {\r\n    color: #0C3058;\r\n    font-size: 20px;\r\n    font-weight: 500;\r\n    padding: 0;\r\n    font-family: 'Rubik';\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.filter-item {\r\n  margin-bottom: 20px;\r\n  border-bottom: 1px solid #C3CFE7;\r\n\r\n  &:last-child {\r\n    margin-bottom: 0;\r\n    border-bottom: 0;\r\n  }\r\n}\r\n\r\n// Responsive Styles\r\n@media (max-width: 991.98px) {\r\n    .filters-container {\r\n        box-shadow: none;\r\n        border-radius: 0;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filters-container": `WqDznpprgABHOjTOo0dc`,
	"filters-title-label": `RBLBzJOqhtZby3nB1A7X`,
	"filter-title": `L36o4cW3F4ELrp95iHA1`,
	"filter-item": `TFKBFReFWwi_Mq3lQIMr`
};
export default ___CSS_LOADER_EXPORT___;
